/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cp_Faq_4_QInputs */

const en_cp_faq_4_q = /** @type {(inputs: Cp_Faq_4_QInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Can it be used for independent-study modules or credit conversion?`)
};

const id_cp_faq_4_q = /** @type {(inputs: Cp_Faq_4_QInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bisakah dipakai untuk MBKM Proyek Independen atau konversi SKS?`)
};

/**
* | output |
* | --- |
* | "Can it be used for independent-study modules or credit conversion?" |
*
* @param {Cp_Faq_4_QInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const cp_faq_4_q = /** @type {((inputs?: Cp_Faq_4_QInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cp_Faq_4_QInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_cp_faq_4_q(inputs)
	return en_cp_faq_4_q(inputs)
});